import React, { useState, useContext } from "react";

import Header from "../../components/Header";
import Abas from "./Componentes/Abas";

import Recebimento from "./Recebimento";
import FaturamentoTabela from "./FaturamentoTabela";
import NaoLoteados from "./NaoLoteados";

import { IntervaloDataContextProvider } from "./Context/IntevervaloDataContext";
import { Context as PermissoesContext } from "../../Context/PermissoesContext";

import "./styles.css";
import { RecebimentoContextProvider } from "./Recebimento/Context/RecebimentoContext";
import { ModalRecebimentoContextProvider } from "./Recebimento/Context/ModalRecebimentoContext";

export default function Faturamento() {
  const { checarPermissaoComAcao } = useContext(PermissoesContext);

  const [tab, setTab] = useState(3);

  const handleTabChange = (newValue) => {
    const n = newValue + 3;
    return checarPermissaoComAcao(`FAT00${n}`, () => setTab(n));
  };

  return (
    <>
      <Header titulo="Faturamento" />
      <IntervaloDataContextProvider>
        <ModalRecebimentoContextProvider>
          <RecebimentoContextProvider>
            <div className="container-central-faturamento">
              <main className="container-abas-faturamento">
                <Abas
                  tabs={["Faturamento", "Recebimento", "Não Loteado"]}
                  value={tab}
                  handleChange={(newValue) => handleTabChange(newValue)}
                />
              </main>
              {tab === 3 && <FaturamentoTabela />}
              {tab === 4 && <Recebimento />}
              {tab === 5 && <NaoLoteados />}
            </div>
          </RecebimentoContextProvider>
        </ModalRecebimentoContextProvider>
      </IntervaloDataContextProvider>
    </>
  );
}
